export default "__VITE_ASSET__CxT8MRtJ__"